import * as t from 'io-ts';

const price = t.type({
  id: t.string,
  name: t.string,
  currencyCode: t.string,
  period: t.string,
  amount: t.string,
});

export const recordCodec = t.type({
  id: t.string,
  name: t.string,
  prices: t.array(price),
});

export const listCodec = t.type({
  data: t.array(recordCodec),
});
